<script setup lang="ts">
/**
 * UI-kit component
 * Category: 'Menus'
 * Name: 'LinkBreadcrumb'
 * FIGMA: ''
 */
import type { LinkBreadcrumbProps } from '../types/interfaces'

defineOptions({
  name: 'LinkBreadcrumb',
})

withDefaults(defineProps<LinkBreadcrumbProps>(), {
  to: '',
  text: '',
  active: false,
  disabled: false,
})

const emit = defineEmits<{
  click: []
}>()

const handleClick = (): void => {
  emit('click')
}
</script>

<template>
  <NuxtLink
    v-if="to && !disabled"
    :to="to"
    class="adm-link-btn"
  >
    {{ text }}
  </NuxtLink>
  <button
    v-else
    type="button"
    :class="['adm-link-btn', { active }]"
    :disabled="disabled"
    @click="handleClick"
  >
    {{ text }}
  </button>
</template>

<style lang="scss" scoped src="../styles/_link-breadcrumb.scss" />
